function AccountAlertsRulesCtrl($scope, $controller, $location,  $timeout, $state, IconsService, GeneralUtilsService) {

	$controller('PolicyFormCtrl', {$scope: $scope, $controller: $controller, $location:$location, $timeout:$timeout, $state:$state,IconsService:IconsService, GeneralUtilsService: GeneralUtilsService});

	$scope.loadAccountManagementRules = function(){
		store.fetch({
			path: "getAccountManagementRules",
			queryParams: {'accountId': $state.params.accountId,'type':'account'},
			success: function(data) {
				$scope.accountM = data;

				parseRules(data);
                handleDirectoryServicesSyncAlerts();

				$scope.orig = angular.copy($scope.accountM);
				$scope.mailingLists = [];
				data.mailingDefinition.mails.forEach(function(list) {
					$scope.mailingLists.push(list.name);
				});
			}
		});
	};

	function parseRules(data){
		$scope.managementRules = {};
		data.managementRules.forEach(function(item){
			$scope.managementRules[item.ruleType] = item;
		});
	}

	$scope.loadAccountManagementRules();

	$scope.accountManagementHasChanges = function(id){
		if(!$scope.accountM) return false;
		return (!angular.equals($scope.orig , $scope.accountM) );
	};

	store.fetch({
		method: "POST",
		path: "/users",
		queryParams:{
			accountId: $state.params.accountId
		},
		success: function(data){
			$scope.admins = data.items;
		}
	});

	$scope.save = function(){
		$scope.accountM.newSaveMethod = true;
		store.save({
			path: "/edit",
			data: $scope.accountM,
			dataObj: 'json',
			queryParams: {'accountId': $state.params.accountId,'save':true,'fields':"['managementRules']"},
			success: function(data) {
				$scope.$root.handleServerResponse(data,"", "Account management rules saved successfully");
				if(data.status !== "ERROR"){
					$scope.loadAccountManagementRules();
				}
			}
		});
	};

    $scope.syncTypeOptions = {
        SCHEDULED_SYNC: 'Scheduled',
        SYNC: 'On-demand',
        ANY: 'Any'
    };

    $scope.actionOptions = {
        SUCCEEDED: 'Succeeded',
        FAILED: 'Failed',
        SUCCEEDED_WITH_WARNING: 'Succeeded with warning',
        ANY: 'Any'
    };

    $scope.alertConstraints = {};

    function handleDirectoryServicesSyncAlerts(){
        if ($scope.managementRules['DIRECTORY_SERVICES'].alertConstraint){
            $scope.alertConstraints = $scope.managementRules['DIRECTORY_SERVICES'].alertConstraint.directoryServiceConstraint;
        }
    };
}